import { FC } from 'react';

import { IndicatorProps, Indicator as MantineIndicator } from '@mantine/core';

const Indicator: FC<IndicatorProps> = ({ children, ...rest }) => {
  return <MantineIndicator {...rest}>{children}</MantineIndicator>;
};

export { Indicator };
export type { IndicatorProps };
